var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#94d4ff",
    d: "M461.93 115.5c5.52 0 10 4.48 10 10s-4.48 10-10 10-10-4.48-10-10 4.48-10 10-10zM461.93 375.5c5.52 0 10 4.48 10 10s-4.48 10-10 10-10-4.48-10-10 4.48-10 10-10z",
    opacity: 1,
    "data-original": "#94d4ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3256c1",
    d: "M411.93 435.5c11.05 0 20 8.95 20 20s-8.95 20-20 20-20-8.95-20-20 8.95-20 20-20z",
    opacity: 1,
    "data-original": "#3256c1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94d4ff",
    d: "M391.93 25.5c5.52 0 10 4.48 10 10s-4.48 10-10 10-10-4.48-10-10 4.48-10 10-10z",
    opacity: 1,
    "data-original": "#94d4ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd400",
    d: "M251.93 55.5c-110.46 0-200 89.54-200 200s89.54 200 200 200 200-89.54 200-200-89.54-200-200-200z",
    opacity: 1,
    "data-original": "#ffd400"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M251.93 405.5c-82.84 0-150-67.16-150-150s67.16-150 150-150 150 67.16 150 150-67.16 150-150 150z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#07cc66",
    d: "M326.279 208.22c7.811 7.81 7.811 20.47 0 28.28l-70.71 70.72-28.28 28.28-28.29-28.28-21.21-21.22c-3.899-3.9-5.859-9.02-5.859-14.14s1.96-10.24 5.859-14.141c7.811-7.81 20.471-7.81 28.28 0l21.22 21.21L298 208.22c3.91-3.9 9.02-5.86 14.14-5.86s10.23 1.96 14.139 5.86z",
    opacity: 1,
    "data-original": "#07cc66",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94d4ff",
    d: "M101.93 455.5c5.52 0 10 4.48 10 10s-4.48 10-10 10c-5.521 0-10-4.48-10-10s4.479-10 10-10z",
    opacity: 1,
    "data-original": "#94d4ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3256c1",
    d: "M76.93 45.5c13.81 0 25 11.19 25 25s-11.19 25-25 25c-13.811 0-25-11.19-25-25s11.189-25 25-25z",
    opacity: 1,
    "data-original": "#3256c1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94d4ff",
    d: "M41.93 125.5c5.52 0 10 4.48 10 10s-4.48 10-10 10c-5.521 0-10-4.48-10-10s4.479-10 10-10zM41.93 375.5c5.52 0 10 4.48 10 10s-4.48 10-10 10c-5.521 0-10-4.48-10-10s4.479-10 10-10z",
    opacity: 1,
    "data-original": "#94d4ff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d0dce7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.93 255.5c0-5.523-4.478-10-10-10s-10 4.477-10 10c0 55.141-44.859 100-100 100-5.523 0-10 4.478-10 10v39.66c3.306.218 6.639.34 10 .34s6.693-.122 10-.34v-30.073c61.506-5.099 110-56.787 110-119.587zM131.93 255.5c0 5.522 4.477 10 10 10 5.522 0 10-4.478 10-10 0-55.14 44.859-100 100-100 5.522 0 10-4.477 10-10v-39.66c-3.307-.218-6.639-.34-10-.34s-6.694.122-10 .34v30.073c-61.506 5.099-110 56.787-110 119.587z",
    fill: "#d0dce7",
    opacity: 1,
    "data-original": "#d0dce7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.9e54e1587b4cba0bdfecbed792a8186f.svg";
export { ForwardRef as ReactComponent };